 

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { GoArrowUpRight } from 'react-icons/go';
import { fetchNotesCatagory } from '../services/operations/notesAPI';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css'; // Import Swiper styles
import { Autoplay, Pagination } from 'swiper';
const NotesCategoryPage = () => {
  const [Button, setButton] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const category = await fetchNotesCatagory();
    if (category) {
      setButton(category);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // if (loading) {
  //   return (
  //     <div className="grid min-h-[calc(100vh)] place-items-center">
  //       <div className="spinner"></div>
  //     </div>
  //   );
  // }

  return (
    <div className="footer2 flex min-h-[60vh] w-full flex-col items-center justify-center p-4 text-richblack-900 md:p-8">
      <h1 className="py-2 text-center text-4xl font-extrabold">
        Explore Our{" "}
        <span className="font-extrabold text-pink-300">Notes</span>
      </h1>
      <p className="text-md text-center font-semibold text-gray-400 md:text-lg">
        Discover a wide range of course and notes categories with CourseCatalyst
      </p>

     
      {loading ? (<div className="grid place-items-center">
        <div className="spinner"></div>
      </div>) : (
        <>

<div className="mt-8 w-full bg-white px-4 md:px-8 py-6">
  <Swiper
    spaceBetween={20} // Adjusted space between slides for a better visual gap
    slidesPerView={1}
    loop={true}
    autoplay={{ delay: 3000, disableOnInteraction: false }} // Autoplay configuration (slides change every 3 seconds)
    pagination={{ clickable: true }} // Dots navigation
    breakpoints={{
      640: {
        slidesPerView: 1, // 1 slide on small screens
      },
      768: {
        slidesPerView: 2, // 2 slides on medium screens
      },
      1024: {
        slidesPerView: 3, // 3 slides on larger screens
      },
    }}
    // modules={[Autoplay, Pagination]} 
    className="swiper-container"
  >
    {Button.map((item, index) => (
      <SwiperSlide key={index}>
        <Link to={`/notes/${item.name.replace(/\s+/g, "-")}`}>
          <div className="footer group my-4 mx-auto max-w-[280px] md:max-w-[350px] lg:max-w-[400px] flex flex-col items-center justify-center gap-4 rounded-xl border-2 border-gray-200 px-6 py-5 text-center transition-transform duration-300 ease-out hover:scale-105 shadow-lg bg-gradient-to-r from-white to-richblack-400 hover:bg-gradient-to-l hover:from-white hover:to-yellow-100">
            <span className="flex flex-row items-center gap-3 text-pink-300 font-semibold text-xl group-hover:text-blue-400">
              {item.name} <GoArrowUpRight className="text-xl" />
            </span>
            <span className="text-sm font-medium text-richblack-800 group-hover:text-richblack-600">
              {item.description}
            </span>
          </div>
        </Link>
      </SwiperSlide>
    ))}
  </Swiper>
</div>
        </>
      )
     }


      <div className="ctg my-10 h-auto w-full rounded-3xl bg-gradient-to-r from-pink-50 to-blue-400 p-4 md:h-40 md:w-[80%] md:p-0">
        <div className="categorysec flex h-full w-full flex-col items-center justify-around gap-4 md:flex-row md:p-5">
          <div className="text-center md:text-left">
            <p className="py-2 text-lg font-semibold text-richblack-800 md:text-xl lg:py-0">
              Feeling Stuck?
            </p>
            <h1 className="text-2xl font-bold text-pink-300 md:text-4xl">
              Gain Insights from <span className="text-white">Top Notes</span>
            </h1>
            <p className="py-3 text-sm font-semibold text-richblack-800">
              Enhance your skills, earn certifications, and stay ahead of the curve with our collection of 50+ trending notes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotesCategoryPage;


// // import React, { useEffect, useState } from 'react';
// // import { Link } from 'react-router-dom';
// // import { GoArrowUpRight } from 'react-icons/go';
// // import { fetchNotesCatagory } from '../services/operations/notesAPI';



// // const NotesCategoryPage = () => {
// //    const [Button, setButton] = useState([]);
// //   const [loading,setLoading] = useState(false)

// //     const fetchData = async () => {
// //     setLoading(true);
// //     const category = await fetchNotesCatagory();
// //     if (category) {
// //       setButton(category);
// //     }
// //     setLoading(false); 
// //   };

// // useEffect(() => {

// //   fetchData();
// // }, []);

// //    if (loading ) {
// //     return (
// //       <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
// //         <div className="spinner"></div>
// //       </div>
// //     )
// //   }

// //   return (
// //     <div className="footer2 flex min-h-[60vh] w-full flex-col items-center justify-center p-4 text-richblack-900 md:p-8">
// //       <h1 className="py-2 text-center text-4xl font-extrabold">
// //         Explore Our{" "}
// //         <span className="font-extrabold text-pink-300">Notes</span>
// //       </h1>
// //       <p className="text-md text-center font-semibold text-gray-400 md:text-lg">
// //         Discover a wide range of course and notes categories with CourseCatalyst
// //       </p>

// //       <div className="mt-8 flex w-full flex-wrap items-center justify-center gap-6 my-10 lg:w-[80%]">
// //         {Button.map((item, index) => (
// //           <Link to={`/notes/${item.name.replace(/\s+/g, "-")}`} key={index}>
// //             <div className="footer group my-2 max-w-xl flex flex-col items-center justify-center gap-3 rounded-xl  border-2 px-5 py-4 text-center transition-transform duration-300 ease-out hover:scale-105 shadow-2xl bg-gradient-to-r from-white to-richblack-400">
// //               <span className="flex flex-row items-center gap-2 text-pink-300 font-bold text-xl  group-hover:text-blue-400">
// //                 {item.name} <GoArrowUpRight className="text-xl" />
// //               </span>
// //               <span className="text-sm font-md text-richblack-800  group-hover:text-richblack-600">{item.description}</span>
// //             </div>
// //           </Link>
// //         ))}
// //       </div>

// //        <div className="ctg my-10 h-auto w-full rounded-3xl bg-gradient-to-r from-pink-50 to-blue-400 p-4 md:h-40 md:w-[80%] md:p-0">
// //         <div className="categorysec flex h-full w-full flex-col items-center justify-around gap-4 md:flex-row md:p-5">
// //           <div className="text-center  md:text-left">
// //             <p className="py-2 text-lg font-semibold text-richblack-800 md:text-xl  lg:py-0">
// //             Feeling Stuck?
// //             </p>
// //             <h1 className="text-2xl font-bold text-pink-300 md:text-4xl">
// //             Gain Insights from <span className="text-white">Top Notes</span>
// //             </h1>
// //             <p className="py-3 text-sm font-semibold text-richblack-800">
// //             Enhance your skills, earn certifications, and stay ahead of the curve with our collection of 50+ trending notes.
// //             </p>
// //           </div>
          
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default NotesCategoryPage;
  

// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { GoArrowUpRight } from 'react-icons/go';
// import { fetchNotesCatagory } from '../services/operations/notesAPI';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/swiper-bundle.min.css'; // Import Swiper styles
// import { Autoplay, Pagination } from 'swiper';
// const NotesCategoryPage = () => {
//   const [Button, setButton] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const fetchData = async () => {
//     setLoading(true);
//     const category = await fetchNotesCatagory();
//     if (category) {
//       setButton(category);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   if (loading) {
//     return (
//       <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
//         <div className="spinner"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="footer2 flex min-h-[60vh] w-full flex-col items-center justify-center p-4 text-richblack-900 md:p-8">
//       <h1 className="py-2 text-center text-4xl font-extrabold">
//         Explore Our{" "}
//         <span className="font-extrabold text-pink-300">Notes</span>
//       </h1>
//       <p className="text-md text-center font-semibold text-gray-400 md:text-lg">
//         Discover a wide range of course and notes categories with CourseCatalyst
//       </p>


// <div className="mt-8 w-full bg-white px-4 md:px-8 py-6">
//   <Swiper
//     spaceBetween={20} // Adjusted space between slides for a better visual gap
//     slidesPerView={1}
//     loop={true}
//     autoplay={{ delay: 3000, disableOnInteraction: false }} // Autoplay configuration (slides change every 3 seconds)
//     pagination={{ clickable: true }} // Dots navigation
//     breakpoints={{
//       640: {
//         slidesPerView: 1, // 1 slide on small screens
//       },
//       768: {
//         slidesPerView: 2, // 2 slides on medium screens
//       },
//       1024: {
//         slidesPerView: 3, // 3 slides on larger screens
//       },
//     }}
//     // modules={[Autoplay, Pagination]} 
//     className="swiper-container"
//   >
//     {Button.map((item, index) => (
//       <SwiperSlide key={index}>
//         <Link to={`/notes/${item.name.replace(/\s+/g, "-")}`}>
//           <div className="footer group my-4 mx-auto max-w-[280px] md:max-w-[350px] lg:max-w-[400px] flex flex-col items-center justify-center gap-4 rounded-xl border-2 border-gray-200 px-6 py-5 text-center transition-transform duration-300 ease-out hover:scale-105 shadow-lg bg-gradient-to-r from-white to-richblack-400 hover:bg-gradient-to-l hover:from-white hover:to-yellow-100">
//             <span className="flex flex-row items-center gap-3 text-pink-300 font-semibold text-xl group-hover:text-blue-400">
//               {item.name} <GoArrowUpRight className="text-xl" />
//             </span>
//             <span className="text-sm font-medium text-richblack-800 group-hover:text-richblack-600">
//               {item.description}
//             </span>
//           </div>
//         </Link>
//       </SwiperSlide>
//     ))}
//   </Swiper>
// </div>

//       <div className="ctg my-10 h-auto w-full rounded-3xl bg-gradient-to-r from-pink-50 to-blue-400 p-4 md:h-40 md:w-[80%] md:p-0">
//         <div className="categorysec flex h-full w-full flex-col items-center justify-around gap-4 md:flex-row md:p-5">
//           <div className="text-center md:text-left">
//             <p className="py-2 text-lg font-semibold text-richblack-800 md:text-xl lg:py-0">
//               Feeling Stuck?
//             </p>
//             <h1 className="text-2xl font-bold text-pink-300 md:text-4xl">
//               Gain Insights from <span className="text-white">Top Notes</span>
//             </h1>
//             <p className="py-3 text-sm font-semibold text-richblack-800">
//               Enhance your skills, earn certifications, and stay ahead of the curve with our collection of 50+ trending notes.
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NotesCategoryPage;
